import React from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';

const DatosBancariosSection = ({ provider, onInputChange }) => {
    return (
        <div className="col-12">
            <Card title="Datos Bancarios">
                <div className="formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="banco">Banco</label>
                        <InputText
                            id="banco"
                            value={provider.BANCO}
                            onChange={(e) => onInputChange(e, 'BANCO')}
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="cuentaNombre">Nombre en Cuenta</label>
                        <InputText
                            id="cuentaNombre"
                            value={provider.CUENTA_NOMBRE}
                            onChange={(e) => onInputChange(e, 'CUENTA_NOMBRE')}
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="cuenta">Cuenta</label>
                        <InputText
                            id="cuenta"
                            value={provider.CUENTA}
                            onChange={(e) => onInputChange(e, 'CUENTA')}
                            type='number'
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="clave">Clave Interbancaria</label>
                        <InputText
                            id="clave"
                            value={provider.CLAVE}
                            onChange={(e) => onInputChange(e, 'CLAVE')}
                            type='number'
                        />
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="tarjetaCredito">Tarjeta de Crédito</label>
                        <InputText
                            id="tarjetaCredito"
                            value={provider.TARJETA_CREDITO}
                            onChange={(e) => onInputChange(e, 'TARJETA_CREDITO')}
                            type='number'
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default DatosBancariosSection;
